import { RelayClientTransport } from '~/modules/remote-mic/network/client/transport/relay-client-transport';
import { PARTYKIT_SERVER } from '~/modules/remote-mic/network/server/transport/party-kit-server';

export class PartyKitClientTransport extends RelayClientTransport {
  protected getUrl = (roomId: string) => `${PARTYKIT_SERVER}/party/${roomId}`;
}
